import Checkbox from '@cobliteam/ui/form/Checkbox';
import Label from '@cobliteam/ui/form/Label';

import type { PlainGeofence } from '@cobliteam/common-types/src/geofenceV3';

interface GeofenceItemProps {
  checked: boolean;
  geofence: PlainGeofence;
  onChange: () => void;
}

const GeofenceItem = ({ checked, onChange, geofence }: GeofenceItemProps) => {
  const { id, name } = geofence;
  return (
    <div className='flex items-center gap-2'>
      <Checkbox id={`${id}-${geofence}`} key={`${id}-${geofence}`} title={name} checked={checked} onCheckedChange={onChange} />
      <Label htmlFor={`${id}-${geofence}`} title={name}>
        {name}
      </Label>
    </div>
  );
};
export default GeofenceItem;
